<template>
  <div
    class="fixed flex justify-center items-center top-0 left-0 w-full h-screen z-50 bg-black/[0.2]"
  >
    <div class="bg-white p-4 w-[90%] max-w-[968px]">
      <div class="font-blod text-lg tracking-wider my-2">視頻鏈接：</div>
      <input
        type="text"
        class="w-full h-9 my-2 rounded"
        placeholder="請寫入視頻鏈接"
        v-model="videoLink"
      />
      <div class="flex justify-center my-2">
        <button type="button" class="btn mx-2" @click="submit">提交</button>
        <button type="button" class="btn mx-2" @click="close">返回</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      videoLink: "",
    };
  },
  methods: {
    submit() {
      this.$emit("getLink", this.videoLink);
      this.videoLink = "";
    },
    close() {
      this.videoLink = "";
      this.$emit("closeVideo");
    },
  },
};
</script>

<style lang="scss" scoped></style>
